import './App.css';
import { Body } from './components/Body';
import Header from './components/Header';



function App() {
  return (
    <div className="App">
      <Header/>
      <Body/>
    </div>
  );
}

export default App;
